const flippIntegrationModule = {};
const MERCHANT_ID = '2135';
const MERCHANT_NAME_ID = 'homedepotusa';
const LOCALE = 'en-US';

flippIntegrationModule.initializeFlippContainer = function initializeFlippContainer(config) {
  const flippContainer = document.querySelector('#flipp-container');
  /* eslint-disable no-undef */
  const storefront = new Flipp.Storefront({
    accessToken: config.flippAccessToken,
    merchantId: MERCHANT_ID,
    merchantNameIdentifier: MERCHANT_NAME_ID,
    locale: LOCALE,
    storeCode: config.storeId
  });

  /* eslint-enable no-undef */
  storefront.renderStorefront(flippContainer);

  return storefront;
};

flippIntegrationModule.createFlippIntegration = function createFlippIntegration(storeId, flippAccessToken) {
  flippIntegrationModule.initializeFlippContainer({
    storeId,
    flippAccessToken
  });
};

export default flippIntegrationModule;